<!-- MAIN VIEW -->
<main
  class="h-full w-screen bg-black overflow-hidden flex flex-col lg:flex-row-reverse"
  id="seat-selection">
  <section
    class="w-full lg:h-full lg:w-[75vw] transition-all ease-in-out duration-700"
    [ngClass]="showTabsOnMobile ? 'h-1/2' : 'h-[calc(100%-3rem)]'">
    @if (availability) {
      <app-viewer
        map
        [baseAvailability]="availability"
        [debugMode]="debugger" />
    }
  </section>

  <!-- h-12 = 3rem -->
  <aside
    class="w-full lg:h-full lg:w-[25vw] transition-all ease-in-out duration-700"
    [ngClass]="showTabsOnMobile ? 'h-1/2' : 'h-12'">
    <app-sidebar
      sidebar
      [debugMode]="debugger"
      [isTabsOpen]="showTabsOnMobile"
      (toggleTabs)="toggleTabsOnMobile()" />
  </aside>

  <!--* DVM POPOVER -->
  <div id="tooltip" class="relative dvmPopover p-2 z-10" role="tooltip">
    <div id="arrow" data-popper-arrow></div>
    <!-- Placement to insert the map popovers -->
    <div #dynamicPopover></div>
  </div>
</main>
